<template>
  <div class="customizer-layout-option">
    <div class="btn-group btn-radio-group" role="group">
      <button type="button" :key="opt.key" v-for="opt in opts" :class="{
        'btn btn-outline-secondary': true,
        'btn-active': opt.key === actKey
        }" @click="click(opt)">
        <i v-if="icon" :class="opt.value"></i>
        <span v-else>{{opt.value}}</span>
      </button>
    </div>
  </div>
</template>
<script>
import filters from '@/mixins/filters'

export default {
  mixins: [
    filters
  ],
  props: {
    options: Array,
    value: [ Object, String, Boolean ],
    unsetTo: String,
    returnKey: {
      type: Boolean,
      default: true
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actKey: function () {
      if (this.value.key !== undefined) return this.value.key

      return this.value
    },
    opts: function () {
      return this.options.map(opt => {
        if (typeof opt === 'string') {
          return {
            key: opt,
            value: this.upperFirst(opt),
            _: true
          }
        }

        return opt
      })
    }
  },
  methods: {
    click: function (opt) {
      if (opt.key === this.actKey) {
        if (this.unsetTo !== undefined) {
          opt = {
            key: this.unsetTo
          }
        } else return
      }

      if (this.returnKey) {
        opt = opt.key
      }

      this.$emit('input', opt)
    }
  }
}
</script>
